module.exports = (value, sing, plural, none = null) => {
    if (value > 1) {
        return `${value} ${plural}`;
    }

    if (none && (value < 1 || !value)) {
        return none;
    }
    return `${value} ${sing}`;
};



// WEBPACK FOOTER //
// ./resources/assets/javascript/templates/plural.js